import { render, staticRenderFns } from "./ManufacturersStoreEdit.vue?vue&type=template&id=3fb225cf&scoped=true&"
import script from "./ManufacturersStoreEdit.vue?vue&type=script&lang=js&"
export * from "./ManufacturersStoreEdit.vue?vue&type=script&lang=js&"
import style0 from "./ManufacturersStoreEdit.vue?vue&type=style&index=0&id=3fb225cf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb225cf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCol,VContainer,VIcon,VImg,VLayout,VRow,VSheet})
